export const publicAr = {
  fulfillment: {
    deliveryOnly: 'هذا الإجراء متاح لطلبات التوصيل فقط.',
    pickupOnly: 'هذا الإجراء متاح للاستلام الذاتي فقط.',
    busy: 'بيانات الطلب قيد التحديث. حاول مجددًا ثم راجع التفاصيل.',
    amountOutOfRange: 'المجموع خارج النطاق المدعوم',
    clientUpdateRequired: 'حدّث الصفحة لمتابعة تأكيد الطلب.',
    pickupStockNotice: 'يتم خصم الكمية عند تأكيد الطلب.',
    pickupNext: 'استلم الطلب من المكان الموضّح. تواصل مع المتجر للتفاصيل.',
    collected: 'تم الاستلام',
    legacySubtotal: 'مجموع المنتجات — رسوم التوصيل غير مسجّلة',
    quoteFailed: 'تعذّر حساب المجموع. حاول مجددًا.',
    quoteLoading: 'جارٍ حساب المجموع',
    loadFailed: 'تعذّر تحميل خيارات الاستلام. حاول مجددًا.',
    optionsChanged: 'تغيّرت الخيارات. راجع التفاصيل والمجموع ثم أكّد مجددًا.',
    unavailable: 'التوصيل والاستلام غير متاحين حاليًا',
    chooseMethod: 'اختر التوصيل أو الاستلام الذاتي',
    pickupPlace: 'مكان الاستلام',
    freePickup: 'استلام ذاتي مجاني',
    freeDelivery: 'توصيل مجاني',
    deliveryFee: 'رسوم التوصيل',
    pickup: 'استلام ذاتي',
    delivery: 'توصيل',
    title: 'طريقة الاستلام',
  },
  common: {
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    loading: 'جارٍ التحميل...',
    error: 'حدث خطأ',
    retry: 'إعادة المحاولة',
    search: 'بحث',
    call: 'اتصال',
    actions: {
      close: 'إغلاق',
    },
    phoneCountry: {
      IL: 'إسرائيل',
      PS: 'فلسطين',
      JO: 'الأردن',
      SY: 'سوريا',
      LB: 'لبنان',
      EG: 'مصر',
      TR: 'تركيا',
      US: 'الولايات المتحدة',
      international: 'رقم دولي',
    },
    languageNames: {
      ar: 'العربية',
      he: 'עברית',
      en: 'English',
    },
    errors: {
      permissionDenied: 'ليس لديك صلاحية لفعل ذلك.',
      networkFailed: 'فشل الاتصال. تحقّق من الشبكة وأعد المحاولة.',
      storeNotFound: 'هذا المتجر لم يعد موجودًا. يرجى تحديث الصفحة.',
      unknown: 'حدث خطأ ما. حاول مرة أخرى.',
    },
  },
  auth: {
    phoneOtp: {
      phoneLabel: 'رقم الهاتف',
      phoneHint: 'أدخل الرقم مع رمز الدولة أو اختر الدولة.',
      codeLabel: 'رمز التحقق',
      codeHint: 'أدخل الرمز المكوّن من 6 أرقام.',
      requestCode: 'إرسال الرمز',
      requestingCode: 'جارٍ الإرسال...',
      verifyCode: 'تأكيد الرمز',
      verifyingCode: 'جارٍ التحقق...',
      retryHandoff: 'إعادة المحاولة',
      resendCode: 'إرسال رمز جديد',
      changePhone: 'تغيير الرقم',
      sentMessage: 'أرسلنا رمز تحقق إلى رقمك.',
      smsOnly: 'سنرسل الرمز برسالة SMS.',
      existingEmailFallback: 'هل لا تملك هاتفًا موثقًا؟',
      useEmailFallback: 'استخدم البريد وكلمة المرور',
      usePhoneOtp: 'استخدم رمز الهاتف',
      errors: {
        phoneRequired: 'رقم الهاتف مطلوب',
        phoneInvalid: 'رقم الهاتف غير صالح',
        codeRequired: 'رمز التحقق مطلوب',
        codeInvalid: 'أدخل رمزًا من 6 أرقام',
        invalidCode: 'الرمز غير صحيح أو انتهت صلاحيته',
        customerAccountMissing: 'لا يوجد حساب زبون لهذا الرقم. أنشئ حسابًا أولًا.',
        rateLimited: 'محاولات كثيرة. حاول بعد قليل.',
        networkFailed: 'فشل الاتصال. تحقق من الشبكة.',
        cartHandoffFailed: 'تم تسجيل الدخول، لكن تعذر نقل السلة. حاول مرة أخرى.',
        profileEnsureFailed: 'تم التحقق من الرقم، لكن تعذر تجهيز حساب الزبون. حاول مرة أخرى.',
        unknown: 'حدث خطأ. حاول مرة أخرى.',
      },
    },
  },
  catalog: {
    products: 'المنتجات',
    outOfStock: 'غير متوفر',
  },
  checkout: {
    cart: 'السلة',
    total: 'المجموع',
  },
  customer: {
    phoneCountryLabel: 'رمز الدولة',
    phoneCountry: {
      IL: 'إسرائيل',
      PS: 'فلسطين',
      JO: 'الأردن',
      SY: 'سوريا',
      LB: 'لبنان',
      EG: 'مصر',
      TR: 'تركيا',
      US: 'الولايات المتحدة',
    },
    signup: {
      title: 'المتابعة برقم الهاتف',
      subtitle: 'رمز تحقق واحد يكفي لمتابعة التسوق.',
      fullNameLabel: 'الاسم الكامل',
      fullNameHint: 'كما تحب أن يراك البائع',
      emailLabel: 'البريد الإلكتروني',
      emailHint: 'سيُستخدم هذا البريد لتسجيل الدخول',
      passwordLabel: 'كلمة المرور',
      passwordHint: '٨ أحرف على الأقل',
      passwordConfirmLabel: 'تأكيد كلمة المرور',
      phoneLabel: 'رقم الهاتف (اختياري)',
      phoneHint: 'يساعد البائع على التواصل معك بخصوص الطلب',
      phoneCountryLabel: 'رمز الدولة',
      phoneCountry: {
        IL: 'إسرائيل',
        PS: 'فلسطين',
        JO: 'الأردن',
        SY: 'سوريا',
        LB: 'لبنان',
        EG: 'مصر',
        TR: 'تركيا',
        US: 'الولايات المتحدة',
      },
      showPassword: 'إظهار كلمة المرور',
      hidePassword: 'إخفاء كلمة المرور',
      submit: 'إنشاء حساب',
      submitting: 'جارٍ الإنشاء...',
      haveAccount: 'لديك حساب بالفعل؟',
      signInLink: 'تسجيل الدخول',
      successToast: 'تم إنشاء حسابك بنجاح!',
      errors: {
        fullNameRequired: 'الاسم الكامل مطلوب',
        fullNameTooShort: 'الاسم قصير جدًا',
        fullNameTooLong: 'الاسم طويل جدًا',
        emailRequired: 'البريد الإلكتروني مطلوب',
        emailInvalid: 'صيغة البريد الإلكتروني غير صحيحة',
        passwordTooShort: 'يجب أن تكون كلمة المرور ٨ أحرف على الأقل',
        passwordConfirmRequired: 'تأكيد كلمة المرور مطلوب',
        passwordMismatch: 'كلمتا المرور غير متطابقتين',
        phoneInvalid: 'رقم الهاتف غير صالح للدولة المختارة',
        emailAlreadyExists:
          'هذا البريد الإلكتروني مسجل بالفعل. إذا كنت تاجرًا، يمكنك تسجيل الدخول بنفس الحساب للتسوق.',
        rateLimited: 'عدد كبير من المحاولات. حاول بعد قليل.',
        networkFailed: 'فشل الاتصال. تحقّق من الإنترنت.',
        accountCreatedSignInFailed: 'تم إنشاء حسابك. حاول تسجيل الدخول بعد قليل.',
        unknown: 'حدث خطأ. حاول مرة أخرى.',
      },
    },
    header: {
      signUpLink: 'المتابعة برقم الهاتف',
      signInLink: 'تسجيل الدخول',
      avatarMenuLabel: 'قائمة الحساب',
      signOut: 'تسجيل الخروج',
      myProfile: 'حسابي',
      myAddresses: 'عناويني',
      myOrders: 'طلباتي',
    },
    login: {
      title: 'المتابعة برقم الهاتف',
      subtitle: 'الزبائن الجدد والعائدون يستخدمون نفس رمز الهاتف.',
      emailLabel: 'البريد الإلكتروني',
      emailHint: 'العنوان الذي استخدمته عند إنشاء الحساب',
      passwordLabel: 'كلمة المرور',
      showPassword: 'إظهار كلمة المرور',
      hidePassword: 'إخفاء كلمة المرور',
      submit: 'تسجيل الدخول',
      submitting: 'جارٍ تسجيل الدخول…',
      forgotPasswordLink: 'نسيت كلمة المرور؟',
      noAccountYet: 'ليس لديك حساب؟',
      signUpLink: 'إنشاء حساب',
      phoneOnlyHint: 'لا تحتاج إلى بريد إلكتروني أو كلمة مرور.',
      errors: {
        emailRequired: 'البريد الإلكتروني مطلوب',
        emailInvalid: 'البريد الإلكتروني غير صالح',
        passwordRequired: 'كلمة المرور مطلوبة',
        invalidCredentials: 'بيانات الدخول غير صحيحة. حاول مرة أخرى.',
        rateLimited: 'محاولات كثيرة. يرجى المحاولة بعد دقائق قليلة.',
        networkFailed: 'فشل الاتصال. تحقق من الشبكة.',
        unknown: 'حدث خطأ. حاول مرة أخرى.',
      },
    },
    passwordReset: {
      request: {
        title: 'إعادة تعيين كلمة المرور',
        subtitle: 'سنرسل رابط إعادة التعيين إلى بريدك الإلكتروني.',
        emailLabel: 'البريد الإلكتروني',
        submit: 'إرسال رابط إعادة التعيين',
        submitting: 'جارٍ الإرسال…',
        successTitle: 'تفقّد بريدك الإلكتروني',
        successMessage:
          'إذا كان هذا البريد مرتبطاً بحساب، ستتلقى رسالة مع رابط إعادة التعيين خلال دقائق قليلة.',
        backToSignIn: 'العودة إلى تسجيل الدخول',
        errors: {
          emailRequired: 'البريد الإلكتروني مطلوب',
          emailInvalid: 'البريد الإلكتروني غير صالح',
          rateLimited: 'محاولات كثيرة. يرجى المحاولة بعد دقائق قليلة.',
          networkFailed: 'فشل الاتصال. تحقق من الشبكة.',
          unknown: 'حدث خطأ. حاول مرة أخرى.',
        },
      },
      confirm: {
        title: 'اختر كلمة مرور جديدة',
        subtitle: 'أدخل كلمة مرور جديدة لإكمال إعادة التعيين.',
        passwordLabel: 'كلمة المرور الجديدة',
        passwordHint: '٨ أحرف على الأقل',
        passwordConfirmLabel: 'تأكيد كلمة المرور',
        showPassword: 'إظهار كلمة المرور',
        hidePassword: 'إخفاء كلمة المرور',
        submit: 'حفظ كلمة المرور الجديدة',
        submitting: 'جارٍ الحفظ…',
        sessionMissingTitle: 'انتهت صلاحية رابط إعادة التعيين',
        sessionMissingMessage: 'يرجى طلب رابط جديد.',
        sessionMissingCta: 'طلب رابط جديد',
        successToast: 'تم تغيير كلمة المرور. أهلاً بك!',
        errors: {
          passwordTooShort: 'يجب أن تكون كلمة المرور ٨ أحرف على الأقل',
          passwordMismatch: 'كلمتا المرور غير متطابقتين',
          rateLimited: 'محاولات كثيرة. يرجى المحاولة بعد دقائق قليلة.',
          networkFailed: 'فشل الاتصال. تحقق من الشبكة.',
          unknown: 'حدث خطأ. حاول مرة أخرى.',
        },
      },
    },
    profilePlaceholder: {
      title: 'صفحة الحساب قادمة قريباً',
      subtitle: 'نحن نعمل على هذه الصفحة. تابعنا قريباً.',
      cta: 'العودة إلى المتجر',
      ariaLabel: 'صفحة الحساب المؤقتة',
    },
    account: {
      pageTitle: 'الحساب',
      ariaLabel: 'صفحة الحساب',
      subtitle: 'إدارة ملفك الشخصي وعناوين التوصيل المحفوظة وطلباتك.',
      navLabel: 'أقسام الحساب',
      items: {
        profile: {
          title: 'الملف الشخصي',
          description: 'عدّل الاسم واللغة المفضلة.',
        },
        addresses: {
          title: 'العناوين المحفوظة',
          description: 'أضف أو عدّل أو اختر عنوان التوصيل الأساسي.',
        },
        orders: {
          title: 'الطلبات',
          description: 'راجع طلباتك الأخيرة وحالتها.',
        },
      },
    },
    profile: {
      pageTitle: 'الملف الشخصي',
      ariaLabel: 'صفحة الملف الشخصي',
      editButton: 'تعديل الملف',
      addressesButton: 'إدارة العناوين المحفوظة',
      saveButton: 'حفظ التغييرات',
      saving: 'جارٍ الحفظ…',
      cancelButton: 'إلغاء',
      nameLabel: 'الاسم',
      emailLabel: 'البريد الإلكتروني',
      emailReadOnly: 'لا يمكن تغيير البريد الإلكتروني حالياً',
      phoneLabel: 'رقم الهاتف',
      phoneOptional: 'اختياري',
      phoneReadOnly: 'رقم الهاتف مثبت من تسجيل الدخول ولا يمكن تغييره هنا.',
      phonePlaceholder: '+972501234567',
      localeLabel: 'اللغة المفضلة',
      localeAr: 'العربية',
      localeHe: 'עברית',
      localeEn: 'English',
      successToast: 'تم حفظ التغييرات بنجاح',
      signOut: 'تسجيل الخروج',
      signingOut: 'جارٍ تسجيل الخروج…',
      deleteAccount: {
        title: 'حذف الحساب',
        warning:
          'هذا الإجراء لا يمكن التراجع عنه. سيتم حذف حسابك نهائياً. ستبقى طلباتك النشطة مرئية للبائع مع بيانات مجهولة الهوية.',
        confirmPrompt: 'اكتب "{{word}}" للتأكيد',
        confirmWord: 'حذف',
        confirmButton: 'حذف الحساب نهائياً',
        deleting: 'جارٍ حذف الحساب…',
      },
      errors: {
        nameRequired: 'الاسم مطلوب',
        nameTooLong: 'الاسم طويل جداً (الحد الأقصى ١٠٠ حرف)',
        phoneInvalid: 'رقم هاتف غير صالح',
        networkFailed: 'فشل الاتصال. تحقق من الشبكة.',
        rateLimited: 'محاولات كثيرة. يرجى المحاولة بعد دقائق قليلة.',
        unknown: 'حدث خطأ. حاول مرة أخرى.',
        deleteFailed: 'فشل حذف الحساب. حاول مرة أخرى.',
      },
    },
    addresses: {
      pageTitle: 'عناويني',
      ariaLabel: 'صفحة العناوين',
      addNewCta: 'إضافة عنوان جديد',
      limitReached: 'وصلت إلى الحد الأقصى (٢٠ عنواناً). احذف عنواناً قديماً لإضافة عنوان جديد.',
      defaultBadge: 'الأساسي',
      makeDefault: 'جعله الأساسي',
      edit: 'تعديل',
      delete: 'حذف',
      actionsMenuLabel: 'إجراءات العنوان',
      empty: {
        title: 'لا توجد عناوين محفوظة بعد',
        body: 'أضف عنواناً لتسريع عملية الدفع.',
        cta: 'أضف عنوانك الأول',
      },
      form: {
        addTitle: 'إضافة عنوان جديد',
        editTitle: 'تعديل العنوان',
        labelLabel: 'التسمية',
        labelPlaceholder: 'مثال: المنزل، العمل',
        labelOptional: 'اختياري',
        recipientNameLabel: 'اسم المستلم',
        addressLine1Label: 'العنوان',
        addressLine2Label: 'سطر العنوان الثاني',
        cityLabel: 'المدينة',
        localitySearchPlaceholder: 'ابحث عن البلدة أو المدينة',
        localitySearchPrompt: 'ابدأ بالكتابة للعثور على البلدة أو المدينة.',
        localityNoResults: 'لا توجد بلدة أو مدينة مطابقة',
        regionLabel: 'المنطقة',
        regionFallbackLabel: 'الولاية / المحافظة',
        postalCodeLabel: 'الرمز البريدي',
        countryLabel: 'الدولة',
        phoneLabel: 'رقم الهاتف',
        phoneOptional: 'اختياري — قد يستخدمه البائع لتنسيق التوصيل.',
        isDefaultLabel: 'اجعل هذا عنواني الأساسي',
        saveNew: 'حفظ العنوان',
        saveEdit: 'حفظ التغييرات',
        cancel: 'إلغاء',
        saving: 'جارٍ الحفظ…',
      },
      districtIL: {
        northern: 'المنطقة الشمالية',
        haifa: 'منطقة حيفا',
        central: 'المنطقة الوسطى',
        tel_aviv: 'منطقة تل أبيب',
        jerusalem: 'منطقة القدس',
        southern: 'المنطقة الجنوبية',
      },
      successToast: {
        created: 'تم حفظ العنوان',
        updated: 'تم تحديث العنوان',
        deleted: 'تم حذف العنوان',
        defaultSet: 'تم تحديث العنوان الأساسي',
      },
      deleteConfirm: {
        title: 'هل تريد حذف هذا العنوان؟',
        body: 'لن يظهر هذا العنوان بعد الآن ضمن خيارات الدفع. الطلبات السابقة لن تتأثر.',
        confirm: 'حذف',
        deleting: 'جارٍ الحذف…',
      },
      errors: {
        labelTooLong: 'التسمية طويلة جداً',
        recipientNameRequired: 'اسم المستلم مطلوب',
        recipientNameTooLong: 'اسم المستلم طويل جداً',
        addressLine1Required: 'العنوان مطلوب',
        addressLine1TooLong: 'العنوان طويل جداً',
        addressLine2TooLong: 'سطر العنوان الثاني طويل جداً',
        cityRequired: 'المدينة مطلوبة',
        cityTooLong: 'اسم المدينة طويل جداً',
        regionRequired: 'المنطقة مطلوبة',
        regionTooLong: 'المنطقة طويلة جداً',
        postalCodeRequired: 'الرمز البريدي مطلوب',
        postalCodeInvalidIL: 'الرمز البريدي الإسرائيلي يجب أن يكون ٥ أو ٧ أرقام',
        postalCodeInvalid: 'رمز بريدي غير صالح',
        countryRequired: 'الدولة مطلوبة',
        phoneInvalid: 'رقم الهاتف غير صالح',
        networkFailed: 'فشل الاتصال. تحقق من الشبكة.',
        rateLimited: 'محاولات كثيرة. حاول بعد دقائق قليلة.',
        notFound: 'العنوان غير موجود.',
        deleteFailed: 'تعذّر حذف العنوان.',
        setDefaultFailed: 'تعذّر تعيين العنوان الأساسي.',
        unknown: 'حدث خطأ. حاول مرة أخرى.',
      },
    },
    // DEPRECATED: F-019 replaced the orders placeholder with the real order
    // history page. These keys are retained for translator reference only.
    // No runtime code references them. Safe to remove in a future cleanup.
    ordersPlaceholder: {
      title: 'الطلبات قادمة قريباً',
      subtitle: 'نحن نعمل على هذه الصفحة. تابعنا قريباً.',
      cta: 'العودة إلى المتجر',
      ariaLabel: 'صفحة الطلبات المؤقتة',
    },
    callback: {
      title: 'جارٍ التحقق...',
      loading: 'لحظة من فضلك، نتحقّق من بريدك الإلكتروني.',
    },
    authGate: {
      title: 'تحقق من رقمك للتواصل مع البائع',
      subtitle: 'للتواصل مع {{storeName}} بشأن {{productName}}، تابع بتحقق الهاتف.',
      signInCta: 'المتابعة برقم الهاتف',
      signUpCta: 'المتابعة برقم الهاتف',
      closeLabel: 'إغلاق',
      primedBanner: {
        message: 'تم تسجيل الدخول — اضغط على "تواصل مع البائع" لإرسال رسالة إلى {{storeName}}',
        dismissLabel: 'تجاهل',
      },
    },
  },
  cart: {
    errors: {
      insufficientStock: 'عذرًا، شخص آخر طلب آخر الوحدات — لم يتبقَّ سوى {{available}}',
      productNotFound: 'المنتج غير موجود',
      notAuthenticated: 'الرجاء تسجيل الدخول للمتابعة',
      permissionDenied: 'ليس لديك الصلاحية لإجراء هذا التغيير',
      networkFailed: 'فشل الاتصال بالشبكة. حاول مرة أخرى.',
      unknown: 'حدث خطأ غير متوقع. حاول مرة أخرى.',
      storeUnpublished: 'هذا المتجر لا يقبل الطلبات حاليًا',
      cartItemNotFound: 'لم يعد هذا المنتج في سلتك. سنحدّث العرض.',
      invalidQuantity: 'تعذّر تحديث الكمية. حاول مرة أخرى.',
      variantUnavailable: 'هذا الخيار لم يعد متاحًا',
      insufficientVariantStock: 'لا توجد كمية كافية لهذا الخيار',
    },
  },
  reviews: {
    verifiedCustomer: 'زبون موثّق',
    verifiedPurchase: 'شراء موثّق',
    merchantResponse: 'ردّ المتجر',
    ratingLabel: '{{rating}} من 5',
    reviewCount: '{{count}} تقييم',
    noReviewsYet: 'لا توجد تقييمات بعد',
    errors: {
      notEligible: 'هذا المنتج غير مؤهل للتقييم',
      alreadyReviewed: 'تم تقييم هذا المنتج',
      permissionDenied: 'ليست لديك صلاحية إرسال هذا التقييم',
      productUnavailable: 'لا يمكن تقييم هذا المنتج الآن',
      ratingInvalid: 'اختر تقييماً من 1 إلى 5',
      textTooLong: 'يجب ألا يتجاوز النص 1000 حرف',
      whitespaceOnly: 'اكتب نصاً واضحاً أو اترك الحقل فارغاً',
    },
  },
  storefront: {
    beauty: {
      shopAll: 'تسوّق جميع المنتجات',
      menu: 'فتح قائمة المتجر',
      closeMenu: 'إغلاق قائمة المتجر',
      search: 'البحث في المتجر',
      searchPlaceholder: 'ابحث عن منتجات',
      closeSearch: 'إغلاق البحث',
      account: 'حسابي',
      cart: 'سلة التسوّق',
      productCount: '{{count}} منتج',
      loadedCount: 'عرض {{loaded}} من {{total}}',
      loadMore: 'عرض المزيد',
      sort: 'ترتيب المنتجات',
      clearSearch: 'مسح البحث',
      noResults: 'لا توجد منتجات تطابق بحثك.',
      selectShade: 'اختر درجة اللون',
      selectOptions: 'اختر الخيارات',
      shadeCount: '{{count}} درجة لون',
      shadeCount_one: 'درجة لون واحدة',
      moreDetails: 'المزيد من التفاصيل',
      details: 'تفاصيل المنتج',
      shippingReturns: 'التوصيل والإرجاع',
      relatedHeading: 'المزيد من هذه الفئة',
      reviews: 'التقييمات',
      ratingSummary: 'التقييم {{average}} من 5 من {{count}} تقييم',
      previous: 'السابق',
      next: 'التالي',
      community: 'مجتمعنا',
      browseProduct: 'عرض {{name}}',
      shop: 'التسوّق',
      contact: 'تواصل معنا',
      policies: 'سياسات المتجر',
      currency: 'الأسعار بالشيكل الإسرائيلي',
      newsletterInert: 'معاينة فقط؛ لا يمكن إرسال الاشتراك هنا.',
      catalogLoadError: 'تعذّر تحميل المنتجات. حاول مرة أخرى.',
      factsLoadError: 'تعذّر تحميل تفاصيل المنتجات الإضافية.',
      chooseOptions: 'اختر جميع الخيارات قبل الإضافة إلى السلة.',
      backToShop: 'العودة للتسوّق',
      newsletterHeading: 'ابقَ على اطلاع',
      newsletterBody: 'اشترك لتلقّي أخبار المتجر.',
      galleryIndex: 'الصورة {{index}} من {{total}}',
      searchSubmit: 'بحث',
      footerGroupToggle: 'فتح أو إغلاق {{group}}',
      communityProductUnavailable: 'المنتج غير متاح',
    },
    website: {
      luxury: {
        categories: 'اكتشف الفئات',
        discoverCategory: 'اكتشف المجموعة',
        bestSellers: 'الأكثر مبيعًا',
        sale: 'التخفيضات',
        newArrivals: 'وصل حديثًا',
        moreFromCategory: 'المزيد من هذه الفئة',
        backToCategory: 'العودة إلى الفئة',
        productDetails: 'تفاصيل المنتج',
        merchandisingError: 'تعذّر تحميل المنتجات. حاول مرة أخرى.',
      },
      fashion: {
        demoWhiteShirt: 'قميص أبيض بأزرار',
        demoBlackBag: 'حقيبة كتف سوداء',
        demoCollection: 'القطع الأساسية',
        viewCollection: 'عرض مجموعة {{category}}',
        campaignLoadError: 'تعذر تحميل هذه المجموعة.',
        collectionUnavailableTitle: 'هذه المجموعة غير متاحة حاليًا',
        collectionUnavailableDescription: 'عُد إلى المتجر لتصفّح المنتجات المتاحة.',
        retry: 'حاولوا مجددًا',
        previousProductImage: 'الصورة السابقة للمنتج {{name}}',
        nextProductImage: 'الصورة التالية للمنتج {{name}}',
        productImagePosition: 'الصورة {{index}} من {{count}} للمنتج {{name}}',
        sizeGuideOpen: 'عرض دليل المقاسات',
        sizeGuideClose: 'إغلاق دليل المقاسات',
        newsletterCompany: 'الشركة',
        sizeGuideTitle: 'دليل المقاسات',
        description: 'الوصف',
        detailsCare: 'التفاصيل والعناية',
        deliveryReturns: 'التوصيل والإرجاع',
        generatedArtwork: 'صور أزياء اصطناعية أصلية أُنشئت لقوالب دكانتي.',
      },
      credits: {
        licenseScope: 'تخضع الصور الأصلية وتعديلاتنا للتراخيص المرتبطة أدناه.',
        title: 'حقوق صور القوالب',
        intro:
          'الصور المستخدمة في قوالب مواقع دوكانتي ومعايناتها. يمكن للتجار استبدالها بصورهم الخاصة.',
        source: 'الصورة الأصلية',
        license: 'الترخيص',
        changes:
          'التعديلات: قصّ الصور وتغيير حجمها وضغطها بصيغة WebP، واستخدامها أيضًا في لقطات معاينة القوالب.',
      },
      updating: {
        reload: 'إعادة تحميل المتجر',
        reloadFailed: 'ما زال المتجر يحتاج إلى إصدار أحدث. حاولوا لاحقًا.',
        title: 'يتم تحديث هذا المتجر',
        body: 'يرجى العودة بعد قليل.',
        browse: 'تصفح دكانتي',
      },
      skipToContent: 'الانتقال إلى المحتوى',
      nav: {
        label: 'تنقل المتجر',
        home: 'الرئيسية',
        shop: 'تسوق',
        about: 'من نحن',
        cart: 'السلة',
        account: 'الحساب',
        search: 'بحث',
        openMenu: 'فتح القائمة',
        closeMenu: 'إغلاق القائمة',
      },
      hero: {
        previous: 'الشريحة السابقة',
        next: 'الشريحة التالية',
        slideStatus: 'الشريحة {{current}} من {{total}}',
      },
      media: {
        pause: 'إيقاف مؤقت',
        play: 'تشغيل',
      },
      categories: {
        heading: 'تسوق حسب الفئة',
      },
      products: {
        newArrivals: 'وصل حديثًا',
        bestSellers: 'الأكثر مبيعًا',
        trending: 'رائج الآن',
        related: 'قد يعجبك أيضًا',
        viewAll: 'عرض الكل',
      },
      about: {
        title: 'عن المتجر',
        delivery: 'التوصيل',
        returns: 'الإرجاع',
        contact: 'التواصل',
      },
      product: {
        careTitle: 'العناية',
        sizeGuideTitle: 'دليل المقاسات',
      },
      confirmation: {
        title: 'تم استلام الطلب',
        continue: 'متابعة التسوق',
      },
      footer: {
        powered: 'مدعوم من دكانتي',
      },
      canvas: {
        checkoutDisabled: 'هذه صفحة إتمام الطلب الحقيقية. إرسال الطلبات متوقف أثناء التعديل.',
        sampleProduct: 'منتج تجريبي',
        sampleCategory: 'فئة تجريبية',
        embeddedBlocked: 'لا يمكن عرض هذه الصفحة هنا.',
        orderConfirmationNotice: 'بعد أن يطلب العميل، يرى تأكيد طلبه هنا.',
        seeOrderConfirmation: 'عرض صفحة تأكيد الطلب',
        notInEditor: 'هذه الصفحة ليست جزءًا من محرر واجهة المتجر.',
        backToStore: 'العودة إلى الصفحة الرئيسية للمتجر',
      },
    },
    storefrontEngine: {
      fallback: {
        sectionUnavailable: 'تعذر عرض هذا القسم الآن.',
      },
      liveCanvas: {
        empty: {
          title: 'بانتظار الباني',
          body: 'يعرض هذا المسار المحتوى فقط بعد أن يبدأ باني الإدارة جلسة لوحة موثوقة.',
        },
        loading: 'بانتظار الباني',
        ready: 'اللوحة جاهزة',
        renderFailed: 'تعذر عرض اللوحة.',
        invalidPayload: 'حمولة اللوحة غير صالحة.',
        invalidRenderData: 'بيانات عرض اللوحة غير صالحة.',
        parityOverlayDisabled: 'تم إخفاء طبقة التحرير للمقارنة.',
        unavailable: 'لوحة العرض الحية غير متاحة.',
        controlsDisabled: 'عناصر تحكم اللوحة غير متاحة مؤقتًا.',
        selectionLabel: 'تحديد قسم من واجهة المتجر',
        sections: {
          hero: 'قسم الواجهة',
          header: 'رأس المتجر',
          footer: 'تذييل المتجر',
          mobileNav: 'تنقل الهاتف',
          benefits: 'المزايا',
          faq: 'الأسئلة الشائعة',
          aboutStore: 'عن المتجر',
          testimonials: 'شهادات',
          newsletterCta: 'دعوة النشرة',
          trustBadge: 'شارة الثقة',
          promotionalAds: 'إعلانات المتجر',
          categories: 'الفئات',
          liveOffers: 'العروض المباشرة',
          products: 'المنتجات',
          trustSummary: 'ملخص الثقة',
        },
        selection: {
          chromeLabel: 'محدد',
          aria: {
            section: 'قسم قابل للاختيار: {{section}}',
            selectedSection: 'القسم المحدد في اللوحة: {{section}}',
          },
        },
        edit: {
          shortLabel: 'تعديل',
          editSection: 'تعديل {{section}}',
          lockedShortLabel: 'مقفل',
          lockedSection: '{{section}} محمي في لوحة البناء',
        },
        textFields: {
          editTextField: 'تعديل {{field}} في {{section}}',
          labels: {
            heroHeadline: 'عنوان الواجهة',
            heroEyebrow: 'عبارة الواجهة',
            heroDescription: 'وصف الواجهة',
            heroPrimaryActionLabel: 'زر الواجهة الرئيسي',
            contentHeading: 'عنوان القسم',
            contentBody: 'نص القسم',
            contentBenefitTitle: 'عنوان الميزة',
            contentBenefitBody: 'نص الميزة',
            contentFaqQuestion: 'سؤال شائع',
            contentFaqAnswer: 'إجابة شائعة',
            contentAboutParagraph: 'فقرة عن المتجر',
            contentTestimonialQuote: 'نص الشهادة',
            contentTestimonialName: 'اسم صاحب الشهادة',
            contentTestimonialContext: 'تفاصيل الشهادة',
            contentNewsletterButton: 'زر النشرة',
          },
        },
        richContentFields: {
          editRichContentField: 'تعديل المحتوى المنسق لـ {{field}} في {{section}}',
          labels: {
            contentBenefitsBody: 'نص المزايا',
            contentBenefitBody: 'نص الميزة',
            contentFaqBody: 'مقدمة الأسئلة الشائعة',
            contentFaqAnswer: 'إجابة شائعة',
            contentAboutParagraph: 'فقرة عن المتجر',
            contentTestimonialsBody: 'مقدمة الاقتباسات',
            contentTestimonialQuote: 'نص الشهادة',
            contentNewsletterBody: 'نص دعوة النشرة',
          },
        },
        mediaFields: {
          replaceMediaField: 'استبدال {{field}} في {{section}}',
          labels: {
            heroDesktop: 'صورة الواجهة للحاسوب',
            heroMobile: 'صورة الواجهة للهاتف',
            trustBadgeImage: 'صورة شارة الثقة',
          },
        },
        add: {
          shortLabel: 'إضافة',
          addAfterSection: 'إضافة قسم بعد {{section}}',
        },
        lifecycle: {
          duplicate: 'نسخ {{section}}',
          hide: 'إخفاء {{section}}',
          show: 'إظهار {{section}}',
          delete: 'حذف {{section}}',
          hiddenPlaceholder: '{{section}} مخفي في المسودة.',
        },
        visibility: {
          deviceHiddenPlaceholder: '{{section}} مخفي في حجم المعاينة هذا.',
        },
        heroSchedule: {
          always: 'نشطة دائما',
          active: 'ظاهرة الآن',
          upcoming: 'مجدولة',
          expired: 'منتهية',
        },
        reorder: {
          handle: 'اسحب لإعادة ترتيب {{section}}',
          moveUp: 'نقل {{section}} قبل القسم السابق',
          moveDown: 'نقل {{section}} بعد القسم التالي',
          dropBefore: 'إفلات قبل {{section}}',
          dropAfter: 'إفلات بعد {{section}}',
          movedBefore: 'تم نقل {{section}} قبل {{target}}.',
          movedAfter: 'تم نقل {{section}} بعد {{target}}.',
        },
        inertAction: 'إجراءات المتسوق معطلة داخل لوحة البناء.',
        aria: {
          route: 'لوحة باني واجهة المتجر',
          selectedSection: 'قسم اللوحة المحدد',
          selectedControls: 'عناصر تحكم اللوحة للقسم {{section}}',
        },
      },
    },
    preview: {
      banner: 'وضع المعاينة',
      expired: 'انتهت صلاحية رابط المعاينة.',
      notAvailable: 'المعاينة غير متاحة.',
      noindexLabel: 'مخفية عن محركات البحث',
      unsupportedTitle: 'صفحة المعاينة غير متاحة',
      unsupportedDescription:
        'هذه الوجهة ليست ضمن المعاينة الآمنة بعد. تابع من الصفحة الرئيسية للمعاينة.',
      backToPreview: 'العودة إلى الصفحة الرئيسية للمعاينة',
    },
    welcome: 'مرحبًا بك في دكانتي',
    shopNow: 'تسوق الآن',
    offerCampaigns: {
      homeRailTitle: 'حملات مباشرة',
      liveBadge: 'عرض مباشر',
      endsIn: 'ينتهي خلال {{time}}',
      endedTitle: 'انتهى هذا العرض',
      endedDescription: 'تحقق من المتجر لمشاهدة عروض أخرى.',
      emptyTitle: 'لا توجد منتجات متاحة في هذا العرض',
      emptyDescription: 'قد تكون المنتجات نفدت أو لم تعد مخفّضة.',
      variantLabel: 'الخيار: {{variant}}',
      homeCta: 'مشاهدة العرض',
      shareLabel: 'مشاركة العرض',
      meta: {
        title: '{{campaignTitle}} من {{storeName}}',
        description: 'عرض مباشر من {{storeName}} لفترة محدودة.',
      },
    },
    courierManifest: {
      title: 'قائمة التوصيل',
      loading: 'جارٍ تحميل قائمة التوصيل...',
      retry: 'إعادة المحاولة',
      error: {
        title: 'تعذّر تحميل قائمة التوصيل',
        description:
          'تحقق من الاتصال وحاول مرة أخرى. إذا استمر الخطأ فاطلب رابطًا جديدًا من المتجر.',
      },
      batchCode: 'دفعة {{displayCode}}',
      courierGreeting: 'لـ {{name}}',
      expiresAt: 'ينتهي في {{expiresAt}}',
      orders: 'توقفات التوصيل',
      orderCount: '{{count}} طلب',
      orderLabel: 'توقف {{displayId}}',
      address: 'العنوان',
      customerPhone: 'هاتف الزبون',
      googleMaps: 'خرائط Google',
      waze: 'Waze',
      packageCount: '{{count}} طرد',
      packageBatchCount: '{{count}} توقفات توصيل',
      notes: 'ملاحظات الزبون',
      openMap: 'فتح الخريطة',
      storeContact: 'اتصال بالمتجر: {{phone}}',
      storeContactUnavailable: 'رقم المتجر غير متاح',
      packageTag: 'الطرد {{tag}}',
      proof: {
        submit: 'إرسال إثبات التوصيل',
        replace: 'استبدال الإثبات',
        submitted: 'تم إرسال الإثبات',
        choosePhoto: 'اختيار صورة',
        chooseFromLibrary: 'اختيار من الصور',
        takePhoto: 'التقاط صورة',
        fileSizeKilobytes: '{{count}} كيلوبايت',
        fileSizeMegabytes: '{{count}} ميجابايت',
        errors: {
          invalidType: 'استخدم صورة JPG أو PNG أو WebP.',
          tooLarge: 'يجب ألا تتجاوز الصورة 5 ميجابايت.',
          notShipped: 'لا يمكن تسليم هذا التوقف من هنا.',
          alreadyConfirmed: 'أكد المتجر هذا التوصيل بالفعل.',
          uploadFailed: 'تعذر رفع صورة الإثبات. حاول مرة أخرى.',
        },
      },
      invalid: {
        title: 'رابط التوصيل غير متاح',
        body: 'قد يكون الرابط منتهيًا أو ملغيًا أو ناقصًا. اطلب رابطًا جديدًا من المتجر.',
        description: 'قد يكون الرابط منتهيًا أو ملغيًا أو ناقصًا. اطلب رابطًا جديدًا من المتجر.',
      },
    },
    courierPortal: {
      title: 'بوابة المندوب',
      invalid: {
        title: 'رابط بوابة المندوب غير متاح',
        description: 'قد يكون الرابط ملغى أو غير صحيح. اطلب رابطًا جديدًا من المتجر.',
      },
      empty: {
        title: 'لا توجد طرود جاهزة الآن',
        description: 'ستظهر هنا الطلبات المشحونة والمخصصة لهذا المندوب.',
      },
      localities: {
        title: 'البلدات',
        count: '{{count}} طرد',
      },
      locality: {
        back: 'العودة إلى البلدات',
      },
      language: {
        label: 'اللغة',
        ar: 'العربية',
        he: 'العبرية',
        en: 'الإنجليزية',
      },
      device: {
        forgetAction: 'إزالة هذا الجهاز',
        title: 'إزالة هذا الجهاز؟',
        description:
          'استخدم هذا الخيار إذا لم يكن هذا هاتفك. لن يفتح هذا الجهاز البوابة مرة أخرى إلا إذا أرسل المتجر الرابط الكامل من جديد.',
        confirm: 'إزالة هذا الجهاز',
      },
      packageCount: '{{count}} طرد',
      customer: 'الزبون',
      proof: {
        required: 'يجب إرسال إثبات التوصيل قبل تأكيد تسليم هذا الطرد.',
        submitted: 'تم إرسال إثبات التوصيل وينتظر تأكيد المتجر.',
        confirmed: 'أكد المتجر إثبات التوصيل.',
      },
    },
    storeChrome: {
      labels: {
        storeHome: 'صفحة المتجر',
        storeCategories: 'التصنيفات',
        storeSales: 'العروض',
        bestSellers: 'الأكثر مبيعًا',
        trendingNow: 'الرائج الآن',
        newArrivals: 'وصل حديثًا',
        category: 'تصنيف',
        cart: 'السلة',
        account: 'الحساب',
        orders: 'الطلبات',
        whatsapp: 'واتساب',
        phone: 'هاتف',
        instagram: 'إنستغرام',
        facebook: 'فيسبوك',
      },
      footer: {
        quickLinks: 'روابط المتجر',
        socialLinks: 'التواصل الاجتماعي',
      },
    },
    home: {
      nav: {
        label: 'تنقل الصفحة الرئيسية',
        home: 'الرئيسية',
        stores: 'المتاجر',
        sales: 'العروض',
        orders: 'طلباتي',
        account: 'الحساب',
      },
      storeNav: {
        home: 'المتجر',
        sales: 'العروض',
      },
      rootLanding: {
        eyebrow: 'دكانتي',
        title: 'رابط متجرك المحلي جاهز عندما تحتاجه',
        subtitle: 'استخدم رابط المتجر الذي وصل إليك، أو أدِر ملفك وطلباتك من هنا.',
        profile: 'الملف الشخصي',
        openStore: 'افتح متجرك',
      },
      hero: {
        badge: 'تسوّق محليًا',
        title: 'اكتشف متاجر محلية',
        subtitle: 'تصفّح متاجر من قريتك واطلب مباشرة من أصحابها.',
        browseStores: 'تصفّح المتاجر',
        openYourStore: 'افتح متجرك',
        fromProduct: 'من منتج منشور',
        fromStore: 'من متجر منشور',
      },
      products: {
        title: 'منتجات من المتاجر المحلية',
        empty: 'لا توجد منتجات منشورة بعد.',
        error: 'تعذّر تحميل المنتجات. حاول مرة أخرى.',
        retry: 'إعادة المحاولة',
        viewProductLabel: 'عرض {{productName}}',
      },
      sales: {
        title: 'تخفيضات وعروض',
        subtitle: 'منتجات مخفّضة من متاجر محلية',
        empty: 'لا توجد تخفيضات متاحة الآن.',
        error: 'تعذّر تحميل التخفيضات. حاول مرة أخرى.',
        retry: 'إعادة المحاولة',
      },
      publishedStores: {
        title: 'المتاجر المحلية',
        empty: 'لا توجد متاجر منشورة بعد.',
        error: 'تعذّر تحميل المتاجر. حاول مرة أخرى.',
        retry: 'إعادة المحاولة',
      },
      featuredStores: {
        title: 'متاجر مميزة',
        empty: 'لا توجد متاجر بعد. كن أول من يفتح متجره!',
        error: 'تعذّر تحميل المتاجر. حاول مرة أخرى.',
        retry: 'إعادة المحاولة',
        viewStore: 'زيارة المتجر',
        viewStoreLabel: 'زيارة المتجر — {{storeName}}',
        storeLogoAlt: 'شعار {{storeName}}',
      },
      howItWorks: {
        title: 'كيف يعمل دكانتي؟',
        step1Title: 'تصفّح المتاجر',
        step1Description: 'اكتشف متاجر محلية من قريتك وتصفّح منتجاتهم.',
        step2Title: 'تواصل مع البائع',
        step2Description: 'تواصل مباشرة مع صاحب المتجر عبر واتساب أو الهاتف.',
        step3Title: 'اطلب واستلم',
        step3Description: 'أكمل طلبك وتابع تفاصيله من حسابك.',
      },
      meta: {
        title: 'دكانتي',
        description: 'ملف العملاء وروابط المتاجر لمتسوّقي دكانتي.',
      },
    },
    sale: {
      onSale: 'تخفيض',
      discountPercent: 'خصم {{percent}}%',
      originalPrice: 'السعر الأصلي {{price}}',
    },
    contactSeller: {
      prefilledMessage: 'السلام عليكم، أنا مهتم بـ {{productName}}. الرابط: {{url}}',
      unavailable: 'معلومات الاتصال غير متوفرة',
      modal: {
        title: 'كيف تحب أن تتواصل؟',
        whatsapp: 'فتح واتساب',
        phone: 'اتصال هاتفي',
        close: 'إغلاق',
      },
    },
    storeNotAvailable: {
      title: 'المتجر غير متاح',
      description: 'هذا المتجر غير متوفّر حاليًا أو لا وجود له.',
      backHome: 'العودة إلى دكانتي',
    },
    storePlaceholder: {
      liveBadge: 'مباشر',
      comingSoon: 'التجربة الكاملة للمتجر قادمة قريبًا',
    },
    storeSales: {
      title: 'منتجات العروض',
      subtitle: 'منتجات مخفّضة من هذا المتجر فقط.',
      emptyTitle: 'لا توجد عروض الآن',
      emptyDescription: 'ارجع إلى هذا المتجر لاحقًا لمشاهدة التخفيضات الجديدة.',
      error: 'تعذّر تحميل منتجات العروض. حاول مرة أخرى.',
      meta: {
        title: 'عروض {{storeName}}',
        description: 'تصفّح المنتجات المخفّضة من {{storeName}}.',
      },
    },
    storeCollections: {
      bestSellers: {
        title: 'الأكثر مبيعًا',
      },
      trendingNow: {
        title: 'الرائج الآن',
      },
      newArrivals: {
        title: 'وصل حديثًا',
      },
      subtitle: 'منتجات مختارة من {{storeName}}',
      emptyTitle: 'لا توجد منتجات في هذه المجموعة بعد',
      emptyDescription: 'عد لاحقًا عندما يحصل هذا المتجر على نشاط أكثر.',
      meta: {
        title: '{{collectionName}} من {{storeName}}',
      },
    },
    customProductCollections: {
      subtitle: 'منتجات مختارة من {{storeName}}',
      emptyTitle: 'لا توجد منتجات في هذه المجموعة الآن',
      emptyDescription: 'ارجع لاحقًا عندما يحدّث هذا المتجر مجموعته.',
      meta: {
        title: '{{collectionName}} من {{storeName}}',
        description: 'تصفّح {{collectionName}} من {{storeName}}.',
      },
    },
    storeCategoriesPage: {
      title: 'كل التصنيفات',
      subtitle: 'تصفّح كل التصنيفات النشطة من {{storeName}}',
      emptyTitle: 'لا توجد تصنيفات بعد',
      emptyDescription: 'لم ينشر هذا المتجر تصنيفات تحتوي على منتجات بعد.',
      error: 'تعذّر تحميل التصنيفات. حاول مرة أخرى.',
      meta: {
        title: 'تصنيفات {{storeName}}',
        description: 'تصفّح كل التصنيفات من {{storeName}}.',
      },
    },
    storeHeader: {
      homeAriaLabel: 'العودة إلى متجر {{storeName}}',
      storeLogoName: 'متجر {{storeName}}',
      cartAriaLabel: 'سلة متجر {{storeName}}',
    },
    // F-005 Phase 4a stub strings. The final Arabic copy is produced by
    // stitch-react during Phase 4c — see §9.1 of
    // .dukanti/designs/F-005.md. We ship recognisable placeholders now
    // so (a) TypeScript's `Translations` type widening is satisfied
    // across he.ts / en.ts, (b) i18next does not fall back visibly and
    // break tests, and (c) a sharp-eyed reviewer can spot missed copy.
    storeHome: {
      header: {
        wordmark: 'دكانتي',
        wordmarkAriaLabel: 'دكانتي — الصفحة الرئيسية',
      },
      languageSwitcher: 'اللغة',
      hero: {
        storeLogoAlt: 'شعار {{storeName}}',
      },
      conversionHero: {
        primaryCta: 'تسوّق الآن',
        categoriesCta: 'تصفّح التصنيفات',
        featuredProduct: 'من المتجر',
        visualFallback: 'لمحة من {{storeName}}',
        descriptionFallback: 'منتجات مختارة من {{storeName}} في مكان واحد.',
      },
      contact: {
        title: 'تواصل مباشر مع المتجر',
        description: 'اختر واتساب أو اتصال هاتفي حسب بيانات التواصل التي نشرها صاحب المتجر.',
        whatsapp: 'واتساب',
        phone: 'اتصال',
        whatsappAriaLabel: 'تواصل مع {{storeName}} عبر واتساب',
        phoneAriaLabel: 'اتصل بـ {{storeName}}',
      },
      products: {
        title: 'المنتجات',
      },
      sections: {
        hero: 'واجهة المتجر',
        contact: 'تواصل مباشر',
        bestSellers: 'الأكثر مبيعًا',
        trendingNow: 'الرائج الآن',
        newArrivals: 'وصل حديثًا',
        specialOffers: 'عروض خاصة',
        selectedProducts: 'منتجات مختارة',
        customCollection: 'مجموعة مختارة',
        sales: 'التخفيضات',
        latestProducts: 'آخر المنتجات',
        availableNow: 'متوفر الآن',
        unavailable: 'غير متوفر حاليًا',
        allProducts: 'كل المنتجات',
        viewAll: 'عرض الكل',
        productsUnavailableHint: 'هذه منتجات منشورة لكنها غير متوفرة للطلب الآن.',
        emptyManualProducts: 'لا توجد منتجات مختارة يمكن عرضها الآن.',
        emptyCustomCollection: 'لا توجد منتجات من هذه المجموعة يمكن عرضها الآن.',
        emptyAutomaticProducts: 'لا توجد منتجات مؤهلة يمكن عرضها الآن.',
        railError: 'تعذّر تحميل هذا القسم.',
        networkError: 'تعذّر تحميل هذا القسم. تحقّق من الاتصال وحاول مرة أخرى.',
        unknownError: 'تعذّر تحميل هذا القسم الآن.',
      },
      newsletter: {
        contactTypeLabel: 'وسيلة التواصل',
        email: 'البريد الإلكتروني',
        phone: 'الهاتف',
        emailLabel: 'عنوان البريد الإلكتروني',
        phoneLabel: 'رقم هاتف إسرائيلي',
        emailPlaceholder: 'name@example.com',
        phonePlaceholder: '050 123 4567',
        consentLabel: 'أوافق على تلقي تحديثات من هذا المتجر عبر وسيلة التواصل التي أكتبها.',
        submit: 'متابعة التحديثات',
        pending: 'جارٍ الحفظ...',
        successTitle: 'شكرًا لك',
        successBody: 'تم استلام طلبك.',
        invalidEmail: 'أدخل عنوان بريد إلكتروني صالحًا.',
        invalidPhone: 'أدخل رقم هاتف إسرائيلي صالحًا.',
        consentRequired: 'أكد الموافقة للمتابعة.',
        genericError: 'تعذّر الحفظ الآن. حاول لاحقًا.',
      },
      trust: {
        title: 'ثقة الزبائن',
        summary: '{{average}} من 5 من {{count}} تقييم موثّق',
        badge: '{{average}} · {{count}} تقييم موثّق',
      },
      categories: {
        title: 'تسوّق حسب التصنيف',
        viewAll: 'عرض الكل',
        viewCategory: 'عرض تصنيف {{categoryName}}',
        productCount: '{{count}} منتج',
        loadError: 'تعذّر تحميل التصنيفات.',
        imageAlt: 'صورة تصنيف {{categoryName}}',
      },
      ads: {
        slideAriaLabel: 'إعلان {{index}} من {{total}}',
        openAd: 'فتح الإعلان',
        destinationCue: 'عرض التفاصيل',
        imageAlt: 'إعلان من {{storeName}}',
        previous: 'الإعلان السابق',
        next: 'الإعلان التالي',
        goToSlide: 'عرض الإعلان {{index}}',
      },
      productImageAlt: 'صورة {{productName}}',
      viewProduct: 'عرض المنتج',
      loadMore: 'عرض المزيد',
      loadingMore: 'جارٍ التحميل...',
      productCard: {
        availability: {
          outOfStock: 'نفد من المخزون',
          onlyNLeft: 'بقي {{count}} فقط',
        },
      },
      empty: {
        title: 'لا توجد منتجات بعد',
        description: 'هذا المتجر لم يُضِف أي منتجات بعد — تفقّده لاحقًا.',
      },
      errors: {
        loadMoreFailed: 'تعذّر تحميل المزيد. حاول مرة أخرى.',
        networkFailed: 'فشل الاتصال. تحقّق من الشبكة.',
        unknown: 'حدث خطأ ما. حاول مرة أخرى.',
        loadFirstFailed: 'تعذّر تحميل المنتجات الآن.',
        loadFirstFailedHint: 'تحقّق من اتصالك بالإنترنت ثم حاول مرة أخرى.',
      },
      liveRegion: {
        loaded: 'يتم عرض {{count}} منتج محمّل',
        loadedFiltered: 'يتم عرض {{visibleCount}} من {{loadedCount}} منتج محمّل',
      },
      loadedFilter: {
        label: 'تصفية المنتجات المحمّلة',
        placeholder: 'اكتب اسم منتج من المنتجات المحمّلة',
        summary: 'يتم عرض {{visibleCount}} من {{loadedCount}} منتج محمّل',
        clear: 'مسح التصفية',
        hideUnavailable: 'إخفاء المنتجات النافدة من المنتجات المحمّلة',
        emptyTitle: 'لا توجد منتجات محمّلة بهذا الاسم',
        emptyDescription: 'امسح التصفية أو حمّل صفحة أخرى إلى المنتجات المعروضة.',
      },
      loading: {
        srLabel: 'جاري تحميل المتجر',
        ariaLabel: 'جاري تحميل المتجر',
      },
      seo: {
        title: '{{storeName}}',
        fallbackDescription: 'تسوّق من {{storeName}}',
      },
    },
    productCard: {
      fromPrice: 'ابتداءً من {{price}}',
      saleFromPrice: 'تخفيض ابتداءً من {{price}}',
    },
    categoryCatalog: {
      backToStore: 'العودة إلى المتجر',
      productCount: '{{count}} منتج',
      search: {
        label: 'البحث داخل {{categoryName}}',
        placeholder: 'ابحث عن منتج في هذا التصنيف',
        clear: 'مسح البحث',
      },
      sort: {
        label: 'ترتيب المنتجات',
        default: 'الافتراضي',
        priceAsc: 'السعر: من الأقل إلى الأعلى',
        priceDesc: 'السعر: من الأعلى إلى الأقل',
        newest: 'الأحدث',
        nameAsc: 'الاسم: أ-ي',
      },
      loading: 'جارٍ تحميل منتجات التصنيف...',
      empty: {
        title: 'لا توجد منتجات مطابقة',
        description: 'جرّب بحثًا آخر أو امسح البحث لرؤية منتجات التصنيف.',
      },
      emptySearch: {
        title: 'لا توجد منتجات تطابق {{search}}',
        description: 'جرّب بحثًا آخر أو امسح البحث لرؤية منتجات التصنيف.',
        clear: 'مسح البحث',
      },
      errors: {
        loadFailed: 'تعذّر تحميل منتجات التصنيف.',
        loadMoreFailed: 'تعذّر تحميل المزيد من منتجات التصنيف.',
        networkFailed: 'تعذّر الاتصال. حاول مرة أخرى.',
        unknown: 'حدث خطأ غير متوقع.',
      },
      liveRegion: {
        loaded: 'يتم عرض {{visibleCount}} من {{totalCount}} منتج',
      },
      meta: {
        title: '{{categoryName}} — {{storeName}}',
        description: 'تسوّق منتجات {{categoryName}} من {{storeName}}.',
      },
    },
    productPlaceholder: {
      title: 'صفحة المنتج قيد التطوير',
      description:
        'نعمل على بناء صفحات المنتجات قريبًا. بإمكانك الرجوع إلى المتجر وتصفّح المنتجات المتوفرة.',
      backToStore: 'العودة إلى المتجر',
    },
    productDetail: {
      backToStore: 'العودة إلى {{storeName}}',
      categoryLabel: 'التصنيف',
      descriptionLabel: 'الوصف',
      contactSeller: 'تواصل مع البائع',
      outOfStock: 'نفد من المخزون',
      availability: {
        inStock: 'متوفر',
        lowStock: 'بقي {{count}} فقط',
        outOfStock: 'نفد من المخزون',
      },
      variants: {
        chooseOption: 'اختر {{option}}',
        available: 'متاح',
        disabled: 'غير متاح للبيع',
        unavailable: 'غير متاح',
        outOfStock: 'نفد من المخزون',
        lowStock: 'تبقى {{count}} فقط',
        selectRequired: 'اختر الخيار المناسب قبل الإضافة للسلة',
      },
      quantity: {
        label: 'الكمية',
        decreaseAriaLabel: 'إنقاص الكمية',
        increaseAriaLabel: 'زيادة الكمية',
        helperMustBeBetween: 'الرجاء إدخال رقم صحيح بين 1 و {{max}}',
        helperExceedsAvailable: 'المتاح {{available}} فقط',
        helperOnlyNLeft: 'بقي {{count}} فقط',
        outOfStockReplacement: 'نفد من المخزون',
        maxInCartReplacement: 'الحد الأقصى موجود في سلتك',
      },
      gallery: {
        previousImage: 'الصورة السابقة',
        nextImage: 'الصورة التالية',
        goToImage: 'الذهاب إلى الصورة {{index}}',
        paginationLabel: 'ترقيم الصور',
        thumbnailLabel: 'الصورة المصغّرة {{index}}',
        noImages: 'لا توجد صور لهذا المنتج',
        zoomImage: 'تكبير الصورة {{index}}',
        zoomOverlayLabel: 'عرض الصورة بالحجم الكامل',
        zoomClose: 'إغلاق',
        zoomCounter: '{{current}} / {{total}}',
        zoomResetZoom: 'إعادة تعيين التكبير',
      },
      seo: {
        title: '{{productName}} — {{storeName}}',
        fallbackDescription: 'تسوّق {{productName}} من {{storeName}}',
      },
      loading: {
        srLabel: 'جاري تحميل المنتج',
      },
      share: {
        button: 'مشاركة',
        copyButton: 'نسخ الرابط',
        shareAriaLabel: 'مشاركة {{productName}}',
        copyAriaLabel: 'نسخ رابط {{productName}}',
        nativeText: '{{productName}} من {{storeName}}',
        toast: {
          sharedTitle: 'تمت مشاركة المنتج',
          copiedTitle: 'تم نسخ الرابط',
          failedTitle: 'تعذّرت المشاركة',
          failedBody: 'لم نتمكن من مشاركة أو نسخ رابط المنتج. حاول مرة أخرى.',
        },
      },
      reviews: {
        title: 'تقييمات الزبائن',
        summary: '{{average}} · {{count}} تقييم',
        retry: 'إعادة تحميل التقييمات',
        yourReviewTitle: 'تقييمك',
        editYourReview: 'تعديل التقييم',
        editTitle: 'تعديل تقييمك',
        saveEdit: 'حفظ التقييم',
        editSuccess: 'تم تحديث تقييمك',
        hiddenOwnReview:
          'هذا التقييم مخفي عن الزبائن حالياً. ستبقى تعديلاتك مرتبطة بنفس عملية الشراء الموثّقة.',
      },
    },
    cart: {
      addToCart: 'أضف إلى السلة',
      adding: 'جارٍ الإضافة…',
      outOfStockButton: 'غير متوفر',
      maxInCartButton: 'الحد الأقصى في السلة',
      persistenceError:
        'لم نتمكن من حفظ هذا المنتج في سلتك على هذا المتصفح. تأكد من إعدادات التخزين أو الوضع الخاص ثم حاول مرة أخرى.',
      successToast: {
        title: 'أُضيف إلى السلة',
        body: '{{productName}} × {{quantity}}',
        viewCart: 'عرض السلة',
      },
      errorToast: {
        title: 'تعذّر الإضافة إلى السلة',
      },
      line: {
        variantSummary: '{{summary}}',
      },
      primedBanner: {
        title: 'نكمل من حيث توقفت — أضف {{storeName}} إلى سلتك',
        dismiss: 'تجاهل',
      },
      postAddPanel: {
        title: 'تمت إضافة {{productName}} إلى السلة',
        body: 'أصبح في سلتك الآن {{quantity}}.',
        viewCart: 'عرض السلة',
        continueShopping: 'متابعة التسوق',
        dismiss: 'إخفاء',
      },
      // F-015: cart header icon + badge + dropdown.
      header: {
        // iconLabel (6 forms)
        iconLabel_zero: 'سلة التسوق فارغة',
        iconLabel_one: 'سلة التسوق — عنصر واحد',
        iconLabel_two: 'سلة التسوق — عنصران',
        iconLabel_few: 'سلة التسوق — {{count}} عناصر',
        iconLabel_many: 'سلة التسوق — {{count}} عنصرًا',
        iconLabel_other: 'سلة التسوق — {{count}} عنصر',

        // static strings
        dropdownTitle: 'سلتك',
        dropdownAriaLabel: 'معاينة السلة',
        subtotal: 'المجموع الفرعي',
        viewCart: 'عرض السلة',
        emptyTitle: 'سلتك فارغة',
        browseProducts: 'تصفح المنتجات',
        // Security W4: pure translated string — no `{{message}}`/raw-error
        // interpolation allowed. A future diff adding one is a merge blocker.
        loadError: 'تعذّر تحميل السلة',

        // itemCountSuffix (6 forms)
        itemCountSuffix_zero: 'لا توجد عناصر',
        itemCountSuffix_one: 'عنصر واحد',
        itemCountSuffix_two: 'عنصران',
        itemCountSuffix_few: '{{count}} عناصر',
        itemCountSuffix_many: '{{count}} عنصرًا',
        itemCountSuffix_other: '{{count}} عنصر',

        // moreItems (6 forms)
        moreItems_zero: '+لا إضافي',
        moreItems_one: '+عنصر إضافي',
        moreItems_two: '+عنصران إضافيان',
        moreItems_few: '+{{count}} عناصر إضافية',
        moreItems_many: '+{{count}} عنصرًا إضافيًا',
        moreItems_other: '+{{count}} إضافية',

        // itemsUnavailable (6 forms)
        itemsUnavailable_zero: 'لا يوجد عناصر غير متوفرة',
        itemsUnavailable_one: 'عنصر واحد لم يعد متوفرًا',
        itemsUnavailable_two: 'عنصران لم يعودا متوفرين',
        itemsUnavailable_few: '{{count}} عناصر لم تعد متوفرة',
        itemsUnavailable_many: '{{count}} عنصرًا لم يعد متوفرًا',
        itemsUnavailable_other: '{{count}} عناصر لم تعد متوفرة',
      },
      // F-016: full cart page strings.
      page: {
        title: 'سلة التسوق',
        subtitle: 'راجع منتجاتك قبل إتمام الشراء',
        breadcrumbBack: 'العودة إلى المتجر',
        empty: {
          title: 'سلتك فارغة',
          body: 'لم تُضِف أي منتج إلى سلتك بعد.',
          browseProducts: 'تصفّح المنتجات',
        },
        line: {
          removeAriaLabel: 'إزالة {{productName}} من السلة',
          unitPrice: '{{price}} للوحدة',
          lineSubtotal: 'المجموع الفرعي للسطر',
          priceUpdated: 'السعر تغيّر',
          priceWas: 'كان: {{oldPrice}}',
          priceNow: 'الآن: {{newPrice}}',
          unavailable: 'غير متوفر',
          unknownProduct: 'لم يعد المنتج متاحًا',
          imageAlt: 'صورة {{productName}}',
        },
        unavailableBanner: {
          title: 'بعض المنتجات لم تعد متاحة',
          body: 'يوجد {{count}} عنصر لم يعد متاحًا للشراء. أزِله للمتابعة إلى تأكيد الطلب.',
        },
        handoffRecovery: {
          retrying: 'نحاول نقل سلتك بعد تسجيل الدخول...',
          partial:
            'لم نستطع نقل كل عناصر السلة. راجع السلة ثم حاول المتابعة لتأكيد الطلب مرة أخرى.',
          savedIntentTitle: 'تحتاج بعض العناصر إلى مراجعة',
          savedIntentBody:
            'هذه عناصر محفوظة من السلة المحلية ولم تُنقل بعد. أزل ما لم تعد تريده، ثم حاول المتابعة مرة أخرى.',
          retrySavedItems: 'حاول نقل العناصر المحفوظة مرة أخرى',
        },
        summary: {
          title: 'ملخّص الطلب',
          subtotal: 'المجموع الفرعي',
          itemCount_zero: 'لا توجد عناصر',
          itemCount_one: 'عنصر واحد',
          itemCount_two: 'عنصران',
          itemCount_few: '{{count}} عناصر',
          itemCount_many: '{{count}} عنصرًا',
          itemCount_other: '{{count}} عنصر',
          stockCheckNote:
            'تبقى المنتجات في سلتك دون حجز المخزون. يتم تأكيد التوفر عند إرسال الطلب.',
          proceedToCheckout: 'المتابعه لتأكيد الطلب',
          checkoutDisabledHint: 'أزِل المنتجات غير المتوفرة قبل المتابعة',
          checkoutDisabledHandoffHint: 'راجِع عناصر السلة المحفوظة أو أزِلها قبل المتابعة',
          signinRequiredDialog: {
            title: 'تحقق من رقمك لتأكيد الطلب',
            body: 'سنرسل رمزًا واحدًا، ثم نعيدك لتأكيد الطلب. ستبقى المنتجات محفوظة في سلتك.',
            continue: 'المتابعة برقم الهاتف',
            cancel: 'البقاء في السلة',
          },
        },
        removeDialog: {
          title: 'إزالة {{productName}}؟',
          body: 'سيتم حذف {{productName}} من سلتك.',
          confirm: 'إزالة',
          cancel: 'إلغاء',
        },
        errors: {
          refetchFailed: 'تعذّر تحميل سلة التسوق. حاول مرة أخرى.',
          updateFailed: 'تعذّر تحديث السلة',
          removeFailed: 'تعذّر إزالة المنتج من السلة',
        },
        toast: {
          removed: 'تمت إزالة {{productName}} من السلة',
        },
        skeleton: {
          loadingAriaLabel: 'جارٍ تحميل سلة التسوق',
        },
        retryButton: 'إعادة المحاولة',
      },
    },
    // F-017: real checkout flow.
    checkout: {
      review: {
        cartChanged: 'تغيّرت المنتجات في سلتك. راجع السلة المحدّثة ثم أكّد من جديد.',
        cartRefreshFailed: 'تعذّر تحديث السلة. حاول مجددًا قبل تأكيد الطلب.',
        verificationFailed: 'تعذّر التحقّق من منتجات السلة. حاول مجددًا قبل التأكيد.',
      },
      page: {
        title: 'إتمام الطلب',
        backToCart: 'العودة إلى السلة',
        shippingSection: 'عنوان التوصيل',
        changeAddress: 'تغيير العنوان',
        useDifferentAddress: 'استخدام عنوان آخر',
        manageAddresses: 'إدارة العناوين المحفوظة',
        saveForNextTime: 'حفظ هذا العنوان للمرة القادمة',
        localityPlaceholder: 'اختر البلدة أو المدينة',
        localityLoading: 'جاري تحميل البلدات...',
        localityError: 'تعذر تحميل البلدات. حاول مرة أخرى.',
        notesSection: 'ملاحظات للبائع',
        submitCta: 'تأكيد الطلب',
        deliveryPriceNoticeTitle: 'سيتم تأكيد سعر التوصيل بشكل منفصل',
        deliveryPriceNotice:
          'سعر التوصيل غير مُضاف حالياً. سيتواصل معك المتجر لتأكيد تكلفة التوصيل قبل إرسال طلبك.',
      },
      deliveryMethod: {
        title: 'طريقة التوصيل',
        location: 'الموقع',
        address: 'العنوان',
      },
      deliveryInfo: {
        title: 'معلومات التوصيل',
        description: 'أخبر المتجر أين يوصّل الطلب. الموقع الدقيق اختياري.',
        localityLabel: 'البلدة أو المدينة',
        postalCodeLabel: 'الرمز البريدي',
        recipientLabel: 'اسم المستلم',
        backupPhoneLabel: 'هاتف بديل',
        errors: {
          localityRequired: 'اختر البلدة أو المدينة.',
          postalCodeRequired: 'أدخل الرمز البريدي.',
          postalCodeInvalid: 'أدخل رمزاً بريدياً إسرائيلياً صالحاً.',
          recipientRequired: 'أدخل اسم المستلم.',
          recipientTooLong: 'اسم المستلم طويل جداً.',
          backupPhoneInvalid: 'أدخل رقم هاتف بديل صالحاً.',
        },
      },
      deliveryLocation: {
        title: 'الموقع الدقيق للتوصيل',
        description: 'شارك موقعك الحالي ليصل التاجر إلى نقطة التوصيل بدقة.',
        localityLabel: 'البلدة أو المدينة',
        localityRequired: 'اختر البلدة أو المدينة قبل مشاركة الموقع.',
        homeWarning:
          'استخدم هذا الخيار فقط عندما تكون في البيت أو في المكان الذي تستقبل فيه الطلبات عادة.',
        cta: 'مشاركة موقعي الدقيق',
        update: 'تحديث الموقع الدقيق',
        locating: 'جاري تحديد الموقع...',
        shared: 'تمت إضافة الموقع الدقيق للتوصيل',
        clear: 'إزالة الموقع',
        denied: 'تم رفض إذن الموقع. يمكنك إتمام الطلب بدون GPS.',
        deniedWithExisting:
          'تم رفض إذن الموقع. سيبقى الموقع الدقيق الذي أضفته سابقاً مرفقاً بهذا الطلب.',
        unavailable: 'الموقع الدقيق غير متاح على هذا الجهاز. يمكنك إتمام الطلب بدون GPS.',
        unavailableWithExisting:
          'الموقع الدقيق غير متاح على هذا الجهاز. سيبقى الموقع الذي أضفته سابقاً مرفقاً بهذا الطلب.',
      },
      locationModal: {
        title: 'مشاركة الموقع الدقيق؟',
        body: 'سيطلب المتصفح إذنك. سنضيف هذه الإحداثيات إلى هذا الطلب فقط.',
        confirmCta: 'مشاركة الموقع',
        cancelCta: 'إلغاء',
      },
      modal: {
        title: 'تأكيد الطلب',
        body: 'أنت على وشك تقديم طلب إلى {{storeName}}.',
        itemCount_one: 'عنصر واحد',
        itemCount_other: '{{count}} عناصر',
        subtotal: 'المجموع الفرعي',
        confirmCta: 'تأكيد',
        cancelCta: 'إلغاء',
      },
    },
  },
  // F-017: order domain namespace.
  order: {
    submit: 'إرسال الطلب',
    confirm: 'تأكيد الطلب',
    cancel: 'إلغاء الطلب',
    placed: 'تم تقديم الطلب',
    tracking: 'تتبّع الطلب',
    shippingAddress: 'عنوان التوصيل',
    deliveryInformation: 'معلومات التوصيل',
    preciseLocation: 'الموقع الدقيق للتوصيل',
    orderSummary: 'ملخّص الطلب',
    stockCheckNotice: 'يتم حجز المخزون عند إرسال الطلب. سيتواصل البائع معك لترتيب التوصيل.',
    notes: {
      placeholder: 'أضف ملاحظات للبائع (اختياري)',
      maxLengthHint: '{{current}}/{{max}}',
    },
    status: {
      ordered: 'تم الطلب',
      shipped: 'تم الشحن',
      delivered: 'تم التسليم',
      cancelled: 'ملغى',
      rejected: 'مرفوض',
    },
    // F-018: order confirmation page keys
    headline: {
      placed: 'تم استلام طلبك!',
      ordered: 'تم استلام طلبك!',
      shipped: 'تم شحن طلبك!',
      delivered: 'تم توصيل طلبك!',
      cancelled: 'تم إلغاء الطلب',
      rejected: 'تم رفض الطلب',
    },
    whatHappensNext: 'ماذا سيحدث الآن؟',
    whatHappensNextBody:
      'سيراجع البائع طلبك ويتواصل معك عبر واتساب أو الهاتف لتأكيد التوصيل وترتيب الدفع. يمكنك متابعة حالة طلبك هنا في أي وقت.',
    contactMerchant: 'تواصل مع البائع',
    contactMerchantWhatsappMessage: 'مرحباً {{storeName}}، أود السؤال عن طلبي رقم {{orderId}}',
    contactMerchantWhatsappAriaLabel: 'مراسلة {{storeName}} عبر واتساب بخصوص هذا الطلب',
    contactMerchantPhoneAriaLabel: 'الاتصال بـ {{storeName}} بخصوص هذا الطلب',
    id: 'رقم الطلب',
    placedDate: 'تاريخ الطلب',
    cancelButton: 'إلغاء الطلب',
    cancelQuestion: 'لديك رأي آخر؟',
    cancelConfirmTitle: 'إلغاء هذا الطلب؟',
    cancelConfirmBody: 'سيتم إلغاء الطلب وإرجاع المنتجات إلى مخزون المتجر.',
    cancelConfirmCta: 'نعم، إلغاء الطلب',
    cancelSuccess: 'تم إلغاء طلبك',
    timeline: {
      title: 'تتبّع الطلب',
      completedOn: 'اكتمل في {{- date}}',
    },
    viewAllOrders: 'عرض جميع طلباتي',
    backToStore: 'العودة إلى المتجر',
    customerNotes: 'ملاحظاتك للبائع',
    loadingDetails: 'جارٍ تحميل تفاصيل الطلب',
    reviewPrompt: {
      title: 'تقييمات هذا الطلب',
      submit: 'إرسال التقييم',
      alreadyReviewed: 'تم تقييم هذا المنتج',
      ratingRequired: 'اختر تقييماً من 1 إلى 5',
      textTooLong: 'يجب ألا يتجاوز النص 1000 حرف',
      whitespaceOnly: 'اكتب نصاً واضحاً أو اترك الحقل فارغاً',
      success: 'تم إرسال تقييمك',
      openDialog: 'كتابة تقييم',
      ratingOnlyHint: 'يمكنك إرسال تقييم بالنجوم فقط أو إضافة نص قصير.',
      reviewedHint: 'تبقى تقييماتك المرسلة مرتبطة بالمنتجات التي استلمتها.',
      yourReview: 'تقييمك',
      editReview: 'تعديل التقييم',
      hiddenReview: 'مخفي عن الزبائن حالياً. تعديلك يحافظ على رابط الشراء الموثّق.',
      merchantResponse: 'رد البائع',
      textLabel: 'نص التقييم',
      textPlaceholder: 'اكتب رأيك بالمنتج',
      dialogTitle: 'تقييم {{productName}}',
      close: 'إغلاق',
    },
    errors: {
      productUnavailable: 'بعض المنتجات لم تعد متوفرة: {{names}}',
      variantUnavailable: 'أحد الخيارات لم يعد متاحًا. راجع السلة.',
      cartEmpty: 'سلتك فارغة. أضف منتجات قبل إتمام الطلب.',
      storeUnavailable: 'هذا المتجر لا يقبل الطلبات حاليًا.',
      networkFailed: 'فشل الاتصال. تحقّق من الشبكة وحاول مرة أخرى.',
      unknown: 'حدث خطأ. حاول مرة أخرى.',
      // F-018: cancel-specific error keys
      cancelFailed: 'تعذّر إلغاء الطلب. حاول مرة أخرى.',
      cancelAlreadyProcessed: 'لا يمكن إلغاء هذا الطلب في حالته الحالية.',
      orderNotFound: 'الطلب غير موجود.',
    },
    history: {
      title: 'طلباتي',
      totalOrders: '{{count}} طلب',
      activeOrders: '{{count}} نشط',
      filterLabel: 'تصفية حسب الحالة',
      filterAll: 'الكل',
      itemCount: '{{count}} منتج',
      viewOrder: 'عرض',
      loadMore: 'تحميل المزيد',
      loadingMore: 'جاري التحميل...',
      loadingOrders: 'جاري تحميل الطلبات',
      backToAccount: 'الحساب',
      emptyAllCta: 'تصفّح المتاجر',
      emptyAllSubtitle: 'استعرض المتاجر وابدأ بالتسوق',
      emptyFilteredHint: 'جرّب تصفية أخرى أو تحقق لاحقاً',
      empty: {
        all: 'لم تقدّم أي طلبات بعد',
        ordered: 'لا توجد طلبات بانتظار الشحن',
        shipped: 'لا توجد طلبات تم شحنها',
        delivered: 'لا توجد طلبات تم توصيلها',
        cancelled: 'لا توجد طلبات ملغاة',
        rejected: 'لا توجد طلبات مرفوضة',
      },
    },
    // F-020: status-change toast key
    statusChangedToast: 'طلبك الآن {{status}}',
  },
  errors: {
    notFound: 'الصفحة غير موجودة',
    networkFailed: 'فشل الاتصال بالشبكة',
    title: 'حدث خطأ غير متوقع',
    description: 'نعتذر عن الإزعاج. يمكنك المحاولة مرة أخرى.',
    retry: 'إعادة المحاولة',
  },
};

export type PublicTranslations = typeof publicAr;
